import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { TRootStackParamList } from '../app/types/exportedTypes';

export const Stack = createNativeStackNavigator<TRootStackParamList>();
